<i18n locale="en" lang="json">
{
  "title": "Terms of use",
  "agree": "I agree",
  "cancel": "Log out",
  "scrollDown": "**Note! Scroll all the way down to agree to the terms of use"
}
</i18n>
<i18n locale="nl" lang="json">
{
  "title": "Gebruikersvoorwaarden",
  "agree": "Ik ben akkoord",
  "cancel": "Log uit",
  "scrollDown": "**Let op! Scroll helemaal naar beneden om de gebruikersvoorwaarden te kunnen accorderen"
}
</i18n>

<template>
  <base-dialog
    ref="dialog"
    :title="t('title')"
    width="750"
    persistent
    :cancelable="false"
  >
    <template #default="{ resolve, isOpen }">
      <gebruikersvoorwaarden-nl v-if="isOpen" />

      <div class="d-flex justify-end">
        <base-button
          class="mr-5"
          :icon="faChevronLeft"
          test-id="cancel"
          @click="resolve(false)"
        >
          {{ t('cancel') }}
        </base-button>
        <base-button
          primary
          :icon="faCheck"
          test-id="agree"
          @click="resolve(true)"
        >
          {{ t('agree') }}
        </base-button>
      </div>
    </template>
    <template #actions>
      <div class="font-weight-bold flex-grow-1">
        {{ t('scrollDown') }}
      </div>
    </template>
  </base-dialog>
</template>

<script lang="ts" setup>
import { defineAsyncComponent, ref } from 'vue';
import { faCheck, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { useI18n } from 'vue-i18n';
import DocumentViewerLoader from '@/common/components/zvdzo/DocumentViewerLoader.vue';
import type { BaseDialogType } from '@/common/components/zvdzo/BaseDialog.types';

const { t } = useI18n();

const GebruikersvoorwaardenNl = defineAsyncComponent({
  loader: () => import('./GebruikersvoorwaardenNl.vue'),
  loadingComponent: DocumentViewerLoader,
});

const dialog = ref<BaseDialogType>();
const open = (): Promise<boolean | undefined> => {
  if (!dialog.value) {
    throw new Error('no dialog');
  }
  return dialog.value.open();
};

defineExpose({ open });
</script>
